// System font stacks — chosen so they look reasonable on macOS, Windows,
// and Linux without loading anything external. Tweak the stacks here to
// taste; data only stores the key ('sans' | 'serif' | ...).
export const LABEL_FONT_STACKS = {
    sans: '"Inter", "Helvetica Neue", "Segoe UI", Arial, sans-serif',
    serif: 'Georgia, "Times New Roman", serif',
    display: 'Impact, "Arial Black", sans-serif',
    mono: 'Menlo, Consolas, "Courier New", monospace',
    hand: '"Bradley Hand", "Comic Sans MS", cursive',
    verdana: 'Verdana, Tahoma, sans-serif',
    trebuchet: '"Trebuchet MS", "Lucida Sans Unicode", sans-serif',
    palatino: 'Palatino, "Palatino Linotype", "Book Antiqua", serif',
    garamond: 'Garamond, "EB Garamond", serif',
    brush: '"Brush Script MT", "Brush Script Std", cursive'
};
export const LABEL_FONT_OPTIONS = [
    { value: 'sans', label: 'Sans' },
    { value: 'serif', label: 'Serif' },
    { value: 'display', label: 'Display' },
    { value: 'mono', label: 'Mono' },
    { value: 'hand', label: 'Hand' },
    { value: 'verdana', label: 'Verdana' },
    { value: 'trebuchet', label: 'Trebuchet' },
    { value: 'palatino', label: 'Palatino' },
    { value: 'garamond', label: 'Garamond' },
    { value: 'brush', label: 'Brush Script' }
];
export const DEFAULT_LABEL_COLOR = '#FFFFFF';
export const DEFAULT_LABEL_SIZE = 16;
export const DEFAULT_LABEL_FONT = 'sans';
export const DEFAULT_LABEL_TEXT = 'Label';
export const LABEL_SIZE_OPTIONS = [
    { value: 12, label: 'Small (12px)' },
    { value: 16, label: 'Medium (16px)' },
    { value: 22, label: 'Large (22px)' },
    { value: 32, label: 'Extra Large (32px)' }
];
export const DEFAULT_LABEL_STYLE = {
    size: DEFAULT_LABEL_SIZE,
    color: DEFAULT_LABEL_COLOR,
    stroke: true,
    bold: false,
    italic: false,
    background: 'none',
    cornerRadius: 'rounded',
    backgroundBorder: false,
    fontFamily: DEFAULT_LABEL_FONT
};
